import {
	HealthAndSafetyIcon,
	IrDoorsIcon,
	IrLiftFloorsIcon,
	IrLiftsIcon,
	SmartGatewaysIcon,
	SmartLockersIcon,
	SmartLockIcon,
	VerkadaCameraIcon,
	ZezamiiAccessIcon,
	ZezamiiGatewaysIcon,
	ZezamiiLockersIcon
} from 'assets/images/svg/Categories';

// Import SVG marker images directly
import HealthAndSafetyMarker from 'assets/images/icon/markers/HealthAndSafetyMarker.svg';
import SmartLockMarker from 'assets/images/icon/markers/SmartLockMarker.svg';
import SmartGatewayMarker from 'assets/images/icon/markers/SmartGatewayMarker.svg';
import SmartLockerMarker from 'assets/images/icon/markers/SmartLockerMarker.svg';
import VerkadaCameraMarker from 'assets/images/icon/markers/VerkadaCamerasMarker.svg';
import ZezamiiAccessMarker from 'assets/images/icon/markers/ZezamiiAccessMarker.svg';
import ZezamiiGatewayMarker from 'assets/images/icon/markers/ZezamiiGatewayMarker.svg';
import ZezamiiLockerMarker from 'assets/images/icon/markers/ZezamiiLockerMarker.svg';
import IrDoorsMarker from 'assets/images/icon/markers/IrDoorsMarker.svg';
import IrLiftsMarker from 'assets/images/icon/markers/IrLiftsMarker.svg';
import IrLiftFloorsMarker from 'assets/images/icon/markers/IrLiftFloorsMarker.svg';

export const defaultCategory = {
	1: {
		name: 'Health & Safety',
		icon: HealthAndSafetyIcon,
		markerIcon: HealthAndSafetyMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	12: {
		name: 'Smart Locks',
		icon: SmartLockIcon,
		markerIcon: SmartLockMarker,
		showOnAdditionalFields: [
			'LockID',
			'Lock Mac',
			'Lock Alias',
			'Has Gateway',
			'Electric Quantity',
			'Lock GroupID',
			'Lock Group Name'
		],
		exportAbleDeviceCustomFields: [
			'Lock Data',
			'LockID',
			'Lock Mac',
			'Lock Alias',
			'Electric Quantity Update Date',
			'Feature Value',
			'Has Gateway',
			'Wireless Keypad Feature Value',
			'Floor Number',
			'Building Number',
			'Lock Name',
			'Special Value',
			'Sector',
			'No Key Pwd',
			'Passage Mode',
			'Date',
			'Timezone Raw Offset',
			'Electric Quantity',
			'Bind Date',
			'Keyboard Pwd Version',
			'Lock Version Show Admin Kbpwd Flag',
			'Lock Version Group ID',
			'Lock Version Protocol Version',
			'Lock Version Protocol Type',
			'Lock Version Org ID',
			'Lock Version Logo URL',
			'Lock Version Scene'
		],
		editableCustomFields: []
	},
	13: {
		name: 'Smart Gateway',
		icon: SmartGatewaysIcon,
		markerIcon: SmartGatewayMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: ['Lock Data'],
		editableCustomFields: []
	},
	14: {
		name: 'Smart Locker',
		icon: SmartLockersIcon,
		markerIcon: SmartLockerMarker,
		showOnAdditionalFields: [
			'LockID',
			'Lock Mac',
			'Lock Alias',
			'Has Gateway',
			'Electric Quantity',
			'Lock GroupID',
			'Lock Group Name'
		],
		exportAbleDeviceCustomFields: [
			'Lock Data',
			'LockID',
			'Lock Mac',
			'Lock Alias',
			'Electric Quantity Update Date',
			'Feature Value',
			'Has Gateway',
			'Wireless Keypad Feature Value',
			'Floor Number',
			'Building Number',
			'Lock Name',
			'Special Value',
			'Sector',
			'No Key Pwd',
			'Passage Mode',
			'Date',
			'Timezone Raw Offset',
			'Electric Quantity',
			'Bind Date',
			'Keyboard Pwd Version',
			'Lock Version Show Admin Kbpwd Flag',
			'Lock Version Group ID',
			'Lock Version Protocol Version',
			'Lock Version Protocol Type',
			'Lock Version Org ID',
			'Lock Version Logo URL',
			'Lock Version Scene'
		],
		editableCustomFields: ['Size', 'Feature']
	},
	15: {
		name: 'Verkada Cameras',
		icon: VerkadaCameraIcon,
		markerIcon: VerkadaCameraMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: ['Lock Data'],
		editableCustomFields: []
	},
	17: {
		name: 'Zezamii Access',
		icon: ZezamiiAccessIcon,
		markerIcon: ZezamiiAccessMarker,
		showOnAdditionalFields: [
			'Lock ID',
			'Alias',
			'Lock Mac',
			'Electric Quantity',
			'Electric Quantity Update Date',
			'Timezone Offset',
			'Automatic Lock Time(in Sec)',
			'Double Lock Flag',
			'Alarm Flag',
			'Sound Flag',
			'Name',
			'Remote Control Flag',
			'Created Date',
			'Updated Date'
		],
		exportAbleDeviceCustomFields: [
			'Lock Data',
			'Lock ID',
			'Alias',
			'Lock Mac',
			'Electric Quantity',
			'Electric Quantity Update Date',
			'Timezone Offset',
			'Automatic Lock Time(in Sec)',
			'Double Lock Flag',
			'Alarm Flag',
			'Sound Flag',
			'Name',
			'Remote Control Flag',
			'Created Date',
			'Updated Date'
		],
		editableCustomFields: []
	},
	18: {
		name: 'Zezamii Gateway',
		icon: ZezamiiGatewaysIcon,
		markerIcon: ZezamiiGatewayMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: ['Lock Data'],
		editableCustomFields: []
	},
	19: {
		name: 'Zezamii Locker',
		icon: ZezamiiLockersIcon,
		markerIcon: ZezamiiLockerMarker,
		editableCustomFields: ['Size', 'Feature'],
		showOnAdditionalFields: [
			'Lock ID',
			'Alias',
			'Lock Mac',
			'Electric Quantity',
			'Electric Quantity Update Date',
			'Timezone Offset',
			'Automatic Lock Time(in Sec)',
			'Double Lock Flag',
			'Alarm Flag',
			'Sound Flag',
			'Name',
			'Size',
			'Feature',
			'Remote Control Flag',
			'Created Date',
			'Updated Date'
		],
		exportAbleDeviceCustomFields: [
			'Lock Data',
			'Lock ID',
			'Alias',
			'Lock Mac',
			'Electric Quantity',
			'Electric Quantity Update Date',
			'Timezone Offset',
			'Automatic Lock Time(in Sec)',
			'Double Lock Flag',
			'Alarm Flag',
			'Sound Flag',
			'Name',
			'Remote Control Flag',
			'Created Date',
			'Updated Date'
		]
	},
	20: {
		name: 'IR Doors',
		icon: IrDoorsIcon,
		markerIcon: IrDoorsMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	21: {
		name: 'IR Lifts',
		icon: IrLiftsIcon,
		markerIcon: IrLiftsMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	},
	22: {
		name: 'IR Lift Floors',
		icon: IrLiftFloorsIcon,
		markerIcon: IrLiftFloorsMarker,
		showOnAdditionalFields: [],
		exportAbleDeviceCustomFields: [],
		editableCustomFields: []
	}
};
